import { initSentry, Sentry } from './lib/sentry';
initSentry();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/private.css';

function FallbackUI() {
  return (
    <div className="auth-site flex h-screen flex-col items-center justify-center px-4 text-center">
      <h1 className="mb-2 text-2xl font-semibold text-app-ink">Something went wrong</h1>
      <p className="mb-6 text-app-muted">An unexpected error occurred. Please try refreshing the page.</p>
      <button
        onClick={() => window.location.reload()}
        className="btn-primary"
      >
        Refresh Page
      </button>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
